<template>
  <div class="about">
    <div class="title">
      <div>联系我们</div>
      <div><img :src="qrcode"/></div>
    </div>
    <p class="desc">《校和家》是由北京君羊教育科技有限公司自主研发的，以教育部《义务教育学校管理标准》和《教育部关于进一步推进高中阶段学校考试招生制度改革的指导意见》为指导方针，完全符合教育部有关规定的、面向中小学的智慧教育（校园信息化）云平台。该平台主要功能包括：家校互动、智慧德育管理（班级、宿舍、学生等评定、处分管理、学生请假出校管理、评优评先管理）、智慧教务管理系统（教学质量检测分析、选课报名、学分评定、教师成长档案、教学科研管理、校本教师培训管理）、综合素质评价管理（5大评价指标－成长记录册－写实记录－遴选审查－形成档案）、智慧团委管理（社团管理信息化、团建管理信息化、志愿服务管理信息化）等功能模块。平台信息通过学校微信群、微信公众号、小程序三种途径到达最终用户。同时，平台支持市－区县－学校三级产品私有部署，构建地区教育局义务教育综合素质评价平台和大数据平台，由教育局和学校完全自主所有，保证了数据的安全可靠。</p>
    <img class="slogn-style" :src="companySlogn"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qrcode: require('../../../assets/qrcode_xhj.jpg'),
      companySlogn: require('../../../assets/slogn.png')
    }
  }
}
</script>


<style lang="less" scoped>
.about {
  .title {
    height: 200px;
    display: flex;
    background-color: #a0d36e;
    div {
      flex: 1;
      &:nth-child(1) {
        text-align: right;
        margin-right: 50px;
        line-height: 200px;
        font-size: 30px;
        color: white;
      }
      &:nth-child(2) {
        margin-left: 50px;
        display: flex;
        align-items: center;
        img {
          height: 140px;
        }
      }
    }
  }
  .desc {
    width: 60%;
    margin: 40px auto;
    font-size: 16px;
    text-align: left;
  }
  .slogn-style {
    margin: 50px 0;
    height: 200px;
  }
}
</style>
